import { render, staticRenderFns } from "./sale-item-table.vue?vue&type=template&id=3e5e322e&scoped=true&"
import script from "./sale-item-table.vue?vue&type=script&lang=js&"
export * from "./sale-item-table.vue?vue&type=script&lang=js&"
import style0 from "./sale-item-table.vue?vue&type=style&index=0&id=3e5e322e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5e322e",
  null
  
)

export default component.exports